import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-close\"><path d=\"m7 7 15.556 15.556M7 23 22.556 7.444\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol